"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Slide = function Slide(_ref) {
  var length = _ref.length,
      index = _ref.index,
      slide = _ref.slide;
  var lengthArray = Array.apply(null, Array(length));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "slide"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: slide.imageUrl,
    loading: "lazy",
    className: "image-slide",
    alt: slide.imageTitle
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "image-slide-title"
  }, ' ', slide.imageTitle, " (", index, " of ", length, ")"), /*#__PURE__*/_react.default.createElement("div", {
    className: "image-slide-description"
  }, slide.imageDescription), lengthArray.map(function (l, i) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: l,
      className: i === index - 1 ? 'dot selected' : 'dot'
    });
  }));
};

Slide.propTypes = {
  length: _propTypes.default.number.isRequired,
  index: _propTypes.default.number.isRequired,
  slide: _propTypes.default.shape({
    imageUrl: _propTypes.default.string.isRequired,
    imageTitle: _propTypes.default.string.isRequired,
    imageDescription: _propTypes.default.string
  })
};
Slide.defaultProps = {
  slide: _propTypes.default.shape({
    imageUrl: '',
    imageTitle: '',
    imageDescription: ''
  })
};
var _default = Slide;
exports.default = _default;